import {
  Flex, Icon, IconButton, Link, Menu, MenuButton, MenuDivider, MenuItem, MenuList, Td, Text, Tr,
} from '@chakra-ui/react';
import { Link as LinkR } from 'react-router-dom';
import {
  BsThreeDotsVertical, BsPencilFill, BsFillTrashFill, BsToggles,
} from 'react-icons/bs';
import { toDate } from '../../helpers/date';
import { useDisableFormMutation, useEnableFormMutation } from '../../Services/apiSlice';

const FormRow = ({
  row: {
    name, date, id, submissions, enabled,
  },
  onDelete,
}) => {
  const [enable] = useEnableFormMutation();
  const [disable] = useDisableFormMutation();

  return (
    <Tr>
      <Td>
        <Flex direction="column">
          <Text fontWeight="bold">
            <Link as={LinkR} to={`/form/${id}`} state={{ title: name }} w="100%" display="inline-block" _hover={{ textDecor: 'none' }}>
              {name}
              {!enabled && <Text as="span" fontWeight="normal" ml="2" color="gray.400">(disabled)</Text>}
            </Link>
          </Text>
          <Text color="gray.400" fontSize="sm">
            Created on:
            {' '}
            {toDate(date)}
          </Text>
        </Flex>
      </Td>
      <Td>{submissions}</Td>
      <Td>
        <Menu>
          <MenuButton
            as={IconButton}
            aria-label="Options"
            icon={<Icon as={BsThreeDotsVertical} />}
            variant="link"
          />
          <MenuList>
            <MenuItem icon={<Icon as={BsPencilFill} />} as={LinkR} to={`/form/${id}/edit`}>
              Edit
            </MenuItem>
            <MenuItem icon={<Icon as={BsToggles} />} onClick={() => (enabled ? disable(id) : enable(id))}>
              {enabled ? 'Disable' : 'Enable'}
            </MenuItem>
            <MenuDivider />
            <MenuItem icon={<Icon as={BsFillTrashFill} />} onClick={() => onDelete({ name, id })}>
              Delete
            </MenuItem>
          </MenuList>
        </Menu>
      </Td>
    </Tr>
  );
};
export default FormRow;
